<template>
    <v-dialog 
        v-model="$store.state.concil.bolDetails"
        transition="dialog-bottom-transition"
        persistent
    >
        <v-container fluid style="padding: 0;overflow: hidden;">
            <v-card>
                <v-toolbar dark color="secondary" dense style="margin-bottom: 15px;">
                    <div style="height: 48px;width: 48px;"></div>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        BOL Details
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="handleCloseBOLDetails"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div style="padding: 20px 50px 30px;display: flex;justify-content: space-evenly;">
                    <h2>BOL: {{ DataBOLDetails.Params.BOL }}</h2>
                    <h2>Delivery Date: {{ DataBOLDetails.Params.DeliveryDate }}</h2>
                </div>
                <v-divider></v-divider>
                <div v-if="render">
                    <v-row style="padding: 20px 50px 10px;">
                        <v-col cols="12">
                            <v-card style="padding-top: 10px;">
                                <v-card-title style="padding-top: 20px;padding-bottom: 30px;">
                                    Upt Transactions
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="uptSearch"
                                        append-icon="mdi-magnify"
                                        label="Search here"
                                        hide-details
                                        style="padding-top: 0;margin-top: 0;margin-left: 30px;"
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="fmtReportData.Data.Upt.Headers"
                                    :items="fmtReportData.Data.Upt.Main"
                                    dense
                                    fixed-header
                                    :search="uptSearch"
                                >
                                    <template v-slot:item.ReconciliationID="{ item }" v-if="customerEditions.ReconciliationID.includes(DataBOLDetails.Params.Customer.Alias)">
                                        <v-text-field
                                            v-model="item.ReconciliationID"
                                            dense
                                            hide-details
                                            @change="updateBOLDetails(item, 'ReconciliationID', 'txn')"
                                        ></v-text-field>
                                    </template>
                                    <template slot="body.append">
                                        <tr>
                                            <td
                                                v-for="(hd, idx) in fmtReportData.Data.Upt.Headers"
                                                :key="idx"
                                            >
                                                <strong 
                                                    v-if="fmtReportData.Data.Upt.Totals[0][hd.value] !== undefined && fmtReportData.Data.Upt.Totals[0][hd.value] !== '$NaN'"
                                                    class="text-left font-weight-bold"
                                                >
                                                    {{ fmtReportData.Data.Upt.Totals[0][hd.value] }}
                                                </strong>
                                                <strong
                                                    v-else
                                                    class="text-left font-weight-bold"
                                                ></strong>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0 50px 30px;">
                        <v-col cols="12">
                            <v-card style="padding-top: 10px;">
                                <v-card-title style="padding-top: 20px;padding-bottom: 30px;">
                                    Payments
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="customerSearch"
                                        append-icon="mdi-magnify"
                                        label="Search here"
                                        hide-details
                                        style="padding-top: 0;margin-top: 0;margin-left: 30px;"
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="fmtReportData.Data.Customer.Headers"
                                    :items="fmtReportData.Data.Customer.Main"
                                    dense
                                    fixed-header
                                    :search="customerSearch"
                                >
                                    <template v-slot:item.UPTOrderID="{ item }" v-if="customerEditions.UPTOrderID.includes(DataBOLDetails.Params.Customer.Alias)">
                                        <v-text-field
                                            v-model="item.UPTOrderID"
                                            dense
                                            hide-details
                                            @change="updateBOLDetails(item, 'UPTOrderID', 'pmt')"
                                        ></v-text-field>
                                    </template>
                                    <template v-slot:item.UPTTranID="{ item }" v-if="customerEditions.UPTTranID.includes(DataBOLDetails.Params.Customer.Alias)">
                                        <v-text-field
                                            v-model="item.UPTTranID"
                                            dense
                                            hide-details
                                            @change="updateBOLDetails(item, 'UPTTranID', 'pmt')"
                                        ></v-text-field>
                                    </template>
                                    <template slot="body.append">
                                        <tr>
                                            <td
                                                v-for="(hd, idx) in fmtReportData.Data.Customer.Headers"
                                                :key="idx"
                                            >
                                                <strong 
                                                    v-if="fmtReportData.Data.Customer.Totals[0][hd.value] !== undefined && fmtReportData.Data.Customer.Totals[0][hd.value] !== '$NaN'"
                                                    class="text-left font-weight-bold"
                                                >
                                                    {{ fmtReportData.Data.Customer.Totals[0][hd.value] }}
                                                </strong>
                                                <strong
                                                    v-else
                                                    class="text-left font-weight-bold"
                                                ></strong>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from "axios";
//import * as XLSX from 'xlsx';

export default {
    props: ['DataBOLDetails', 'CallUpdate'],
    data: function () {
        return {
            customerSearch: '',
            uptSearch: '',
            render: false,
            fmtReportData: {},
            customerEditions: {
                UPTTranID: ['Parkland', 'Suncor'],
                UPTOrderID: ['MrGas', 'ShellCP', 'KAG', 'CPRail', 'Valero', 'BPProducts', 'CK'],
                ReconciliationID: ['MrGas', 'CPRail', 'CK', 'ShellCP', 'KAG', 'Valero', 'BPProducts', 'Suncor', 'Parkland']
            },
            updatePending: false,
        }
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        prepareData: function () {
            console.log(this.DataBOLDetails);
            this.formatData();
        },
        formatData: function () {
            this.fmtReportData = JSON.parse(JSON.stringify(this.DataBOLDetails));
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
            });

            for (let version in this.DataBOLDetails.Data) {
                this.fmtReportData.Data[version].Main.forEach(row => {
                    this.fmtReportData.Data[version].CurrencyFormat.forEach(fmt => {
                        row[fmt] = cad.format(row[fmt]);
                    });
                });

                this.fmtReportData.Data[version].Totals.forEach(row => {
                    this.fmtReportData.Data[version].CurrencyFormat.forEach(fmt => {
                        row[fmt] = cad.format(row[fmt]);
                    });
                });
            }

            console.log(this.fmtReportData);
            this.render = true;
        },
        updateBOLDetails: async function(item, type, target) {
            console.log(item);

            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                Customer: this.DataBOLDetails.Params.Customer,
                Target: target,
            };

            switch (type) {
                case 'UPTOrderID':
                    params.OrderID = item.UPTOrderID;
                    params.ReconciliationID = item.ReconciliationID;
                    break;
                case 'UPTTranID':
                    params.TransactionID = item.UPTTranID;
                    params.ReconciliationID = item.ReconciliationID;
                    break;
                case 'ReconciliationID':
                    params.ReconciliationID = item.ReconciliationID;
                    params.TransactionID = item.TranId;
                    break;
                default:
                    break;
            }

            console.log(params);
            await axios
                .post('conciliation/update/bol-details', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Data successfully updated.'
                    });
                    str.state.isLoading = false;
                    this.updatePending = true;
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Error updating data.'
                    });
                    str.state.isLoading = false;
                });
        },
        handleCloseBOLDetails: function () {
            console.log("handleCloseBOLDetails");
            if (this.CallUpdate) {
                this.$emit('close', this.updatePending);
            }
            this.$store.state.concil.bolDetails = false;
        }
    }
}
</script>